// Aviso de carona acima do Backlog (ADR-0027/0028): a Devolvida passa do que
// havia no Backlog do Cliente até esta devolução. Diz quanto havia e, se
// peças entraram no Backlog depois desta devolução, de qual OS — elas não
// contam e são o motivo de a tela de Backlog mostrar peças que o Fechamento
// não vê (OS 437/436). Puro: a Ficha mostra e o "Fechar OS" recusa com o
// mesmo texto.

import type { EntradaPosterior, SaidaPosterior } from "./backlog.ts";
import { formatData, isDataISO, type DataISO } from "./datas.ts";
import { emTexto, type Trecho } from "./situacao-retencao.ts";

function quando(data: DataISO, hora: string | null): string {
  // na Ficha a data pode ainda estar em branco
  if (!isDataISO(data)) return "sem data de devolução";
  return `${formatData(data)}${hora ? ` ${hora}` : ""}`;
}

/** Uma linha por aviso: o que falta, e o que entrou depois (se houver). */
export function avisoCaronaSemSaldo(e: {
  falta: number;
  havia: number;
  devolucao: { data: DataISO; hora: string | null };
  depois: readonly EntradaPosterior[];
  /** Peças que havia na data mas já saíram por OS devolvida depois (ou Perda). */
  sairam?: readonly (SaidaPosterior & { faturada: boolean })[];
}): Trecho[][] {
  const linhas: Trecho[][] = [
    [
      "Devolvida passa ",
      { n: e.falta },
      " do Backlog: havia ",
      { n: e.havia },
      ` até esta devolução (${quando(e.devolucao.data, e.devolucao.hora)}). Cadastre o Backlog Inicial ou corrija a Devolvida.`,
    ],
  ];
  if (e.sairam && e.sairam.length > 0) {
    const soma = e.sairam.reduce((a, s) => a + s.quantidade, 0);
    const onde = e.sairam
      .map((s) =>
        s.os == null
          ? `Perda, ${quando(s.data, s.hora)}`
          : `OS ${s.os}, ${quando(s.data, s.hora)}${s.faturada ? ", faturada" : ""}`,
      )
      .join("; ");
    linhas.push([{ n: soma }, ` já ${soma === 1 ? "saiu" : "saíram"} depois desta devolução (${onde}).`]);
  }
  if (e.depois.length > 0) {
    const soma = e.depois.reduce((a, d) => a + d.quantidade, 0);
    const origens = e.depois.map((d) => `OS ${d.os}, ${quando(d.data, d.hora)}`).join("; ");
    linhas.push(["As ", { n: soma }, ` que estão hoje no Backlog entraram depois desta devolução (${origens}).`]);
  }
  return linhas;
}

/** As linhas do aviso como texto corrido — a recusa do "Fechar OS". */
export function avisoCaronaEmTexto(linhas: readonly Trecho[][]): string {
  return linhas.map(emTexto).join(" ");
}
